import React from 'react'
import Contact from '../Pages/Contact'
import Header from '../Components/Header'
import Footer from '../Components/Footer'


function ContactLayout() {
  return (
   <>
   <Header />
   <Contact />
   <Footer />
   </>
  )
  
}

export default ContactLayout